module.exports = __webpack_public_path__ + "database-development._HvZ4BYk.svg";